import { render, staticRenderFns } from "./RouteFileNewLogbooksPage.vue?vue&type=template&id=c8111eac&"
import script from "./RouteFileNewLogbooksPage.vue?vue&type=script&lang=js&"
export * from "./RouteFileNewLogbooksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports